import { FunctionComponent } from 'react';
import { SIMainModal } from 'widgets/auth/signIn/_MainModal';

export const SignIn: FunctionComponent = () => {
	return <SIMainModal />;
};
